export default __webpack_public_path__ + "static/media/IMG_8842 copie.262d2e97.jpg";